
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/start-here/core-technology-discussions/komodo-defi-framework",
      function () {
        return require("private-next-pages/en/docs/start-here/core-technology-discussions/komodo-defi-framework/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/start-here/core-technology-discussions/komodo-defi-framework"])
      });
    }
  